import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { BootstrapIcon, HeaderService } from "src/app/services/header.service";
import { ModalComponent } from "src/app/shared/components/modal/modal.component";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { NavigationService } from "src/app/shared/data-access/navigation.service";

enum childComponents {
  FormComponent = "workstationFormComponent",
  SelectionComponent = "selectProductionLineComponent",
}

@Component({
  selector: "app-admin-workstation-management",
  template: `
    <h1 class="qundis-page-heading-h1">{{ getPageHeading() }}</h1>
    <router-outlet></router-outlet>
  `,
  standalone: true,
  imports: [CommonModule, ModalComponent, RouterModule],
})
export class AdminWorkstationManagementComponent implements OnInit {
  headerService = inject(HeaderService);
  navigationService = inject(NavigationService);
  route = inject(ActivatedRoute);
  public BootstrapIcon = BootstrapIcon;

  ngOnInit(): void {
    this.headerService.setHeaderIcon(BootstrapIcon.workstations);
    this.headerService.setHeaderTitle("Arbeitsplatzverwaltung");
  }

  getPageHeading() {
    switch (this.navigationService.activeComponent()) {
      case childComponents.SelectionComponent:
        this.headerService.setHeaderSubTitle("Gesamtübersicht");
        return "Gelistete Arbeitsplätze";
      case childComponents.FormComponent:
        if (this.navigationService.currentUrl().includes("formAction=edit")) {
          this.headerService.setHeaderSubTitle("Arbeitsplatz bearbeiten");
          return "Arbeitsplatz bearbeiten";
        } else {
          this.headerService.setHeaderSubTitle("Neuen Arbeitsplatz anlegen");
          return "Neuen Arbeitsplatz anlegen";
        }
      default:
        return "Gelistete Arbeitsplätze";
    }
  }
}
